import React from 'react';
import { Icon } from '@noths/polaris-design-system-core-components';

import * as styles from './FreePartnerDeliveryMessage.styles';

export interface FreePartnerDeliveryMessageProps {
  formattedThreshold: string;
  partnerName: string;
}

export const FreePartnerDeliveryMessage = ({
  formattedThreshold,
  partnerName,
}: FreePartnerDeliveryMessageProps) => (
  <p css={styles.root}>
    <Icon name="sale" size="md" />
    <span>
      Spend {formattedThreshold}+ with {partnerName} and get <b>FREE standard delivery</b>
    </span>
  </p>
);
